import * as React from 'react'

import { Skeleton } from '@factorialco/deprecated-design-system'

const AssessmentItemLoadingState: React.FC = () => {
  return <Skeleton height="s80" />
}

export default AssessmentItemLoadingState
